module.exports = __webpack_public_path__ + "static/media/map.49a791be.webp";